import { useMemo } from 'react'
import { connect } from 'react-redux'
import { BnblPackageImageAndName } from './BnblPackageImageAndName'
import BnblPackageRooms from './BnblPackageRooms'

interface MappedProps {
  bnblModalPackages: Array<App.BnblModal>
}

interface Props {
  offer: App.Offer
}

function BnblMultipleRoomPackage({
  offer,
  bnblModalPackages,
}: Props & MappedProps) {
  const { id: offerId } = offer

  const roomPackages = useMemo(() => (
    bnblModalPackages.map(roomPackage => {
      const {
        duration,
        name: packageName,
        roomType: { name: roomTypeName, images },
        uniqueKey,
      } = roomPackage.packageView.package

      return { duration, packageName, roomTypeName, image: images[0], uniqueKey }
    })
  ), [bnblModalPackages])

  return (
    <>
      {roomPackages.map(pkg => (
        <>
          <BnblPackageImageAndName
            image={pkg.image}
            packageName={pkg.packageName}
            roomTypeName={pkg.roomTypeName}
          />
          <BnblPackageRooms
            offerId={offerId}
            packageKey={pkg.uniqueKey}
          />
        </>
      ))}
    </>
  )
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  return {
    bnblModalPackages: state.offer.bnblModal[ownProps.offer.id],
  }
}

export default connect(mapStateToProps)(BnblMultipleRoomPackage)
